import NestedRouteComponent from 'router/nestedViews/NestedRouteComponent';
import wrapLegacyRoute from 'router/legacy/wrapLegacyRoute';
import translation from 'translation';

const accountMarkupsRoutes = [
  {
    path: 'markups',
    component: NestedRouteComponent,
    meta: {
      routeName: {
        segmentName: () => translation.tr('Markups')
      },
      permissions: ['READ_MARKUPS', 'READ_NETTO_COST']
    },
    children: [
      {
        path: '',
        name: 'markupsList',
        component: wrapLegacyRoute('markupsController', 'list')
      },
      {
        path: 'create',
        name: 'markupCreate',
        component: wrapLegacyRoute('markupsController', 'create')
      },
      {
        path: ':markupId(\\d+)',
        name: 'markupDetails',
        component: wrapLegacyRoute('markupsController', 'details')
      }
    ]
  }
];

export default accountMarkupsRoutes;
